module.exports = __webpack_public_path__ + "static/apple-touch-icon-b470e27fe5348e33a0bacfdccb926093.png";